/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

    /* === Promo Block Section === */

    const promoApply = document.querySelector('.promo-apply');

    function applyPromo(e) {
        const xhr = new XMLHttpRequest();
        const currentTarget = e.currentTarget;

        xhr.open('GET', '/discount/' +  currentTarget.dataset.promoCode, true);
        xhr.send();

        xhr.onreadystatechange = function() {
            if (xhr.readyState !== 4) return;
            currentTarget.classList.remove('promo-apply--loading');

            if (xhr.status === 200) currentTarget.classList.add('promo-apply--applied');
        };

        currentTarget.classList.add('promo-apply--loading');
    }

    if (promoApply) promoApply.addEventListener('click',  applyPromo);

    /* === Promo Block Section End === */


    /* === Yotpo Reviews Hash Scroll === */

    (function () {
      var HASH = '#yotpo-reviews-main-widget';
      var HEADER_OFFSET = 80; // adjust if sticky header height changes

      if (window.location.hash !== HASH) return;

      function scrollToTarget(el) {
        var top = el.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }

      function waitForYotpo() {
        var el = document.getElementById('yotpo-reviews-main-widget');
        if (el) {
          scrollToTarget(el);
          return;
        }

        var observer = new MutationObserver(function () {
          var el = document.getElementById('yotpo-reviews-main-widget');
          if (el) {
            observer.disconnect();
            // Delay scroll to allow Yotpo to finish rendering its content
            setTimeout(function () { scrollToTarget(el); }, 600);
          }
        });

        observer.observe(document.body, { childList: true, subtree: true });

        // Safety timeout — disconnect after 10s to avoid leaking
        setTimeout(function () { observer.disconnect(); }, 10000);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForYotpo);
      } else {
        waitForYotpo();
      }
    })();

    /* === Yotpo Reviews Hash Scroll End === */


  
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
